import { render, staticRenderFns } from "./CreateEmergencyContactModal.vue?vue&type=template&id=24d2e6eb&scoped=true"
import script from "./CreateEmergencyContactModal.vue?vue&type=script&lang=js"
export * from "./CreateEmergencyContactModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEmergencyContactModal.vue?vue&type=style&index=0&id=24d2e6eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d2e6eb",
  null
  
)

export default component.exports